import { useEffect } from "react";
import { FullScreenSpinner } from "../components/exports";
import { getAuthManager } from "../utils/auth";

export default function SilentCallback() {
    useEffect(() => {
        const auth = getAuthManager();
        auth.completeSilentAuthentication().catch((error) => {
            console.error("OIDC silent callback failed:", error);
        });
    }, []);

    return <FullScreenSpinner />;
}
